export default __webpack_public_path__ + "static/media/shoppinglist_male@3x.fd16e51e.png";